class SocialSharing extends HTMLElement {
  connectedCallback() {
    this.copyButtons = this.querySelectorAll(".social-sharing__copy-button");
    this.copyButtons.forEach((button) => {
      button.addEventListener("click", (event) => this.handleCopyClick(event));
    });
  }

  async handleCopyClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const url = button.getAttribute("data-copy-url");

    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) return;

      await navigator.clipboard.writeText(url);
      this.showTooltip(button);
    } catch (error) {
      console.error("Failed to copy URL:", error);
    }
  }

  showTooltip(button) {
    const tooltip = document.createElement("span");
    tooltip.className = "social-sharing__tooltip";
    tooltip.textContent = button.getAttribute("data-copy-text");
    button.appendChild(tooltip);

    // Remove tooltip after 2 seconds
    setTimeout(() => {
      tooltip.remove();
    }, 2000);
  }
}

if (!customElements.get("social-sharing")) {
  customElements.define("social-sharing", SocialSharing);
}
